module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/redux-act-async/~/babel-runtime/core-js/object/assign.js
// module id = 2101
// module chunks = 0